import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ModalService } from '../../../../../services/modal.service';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { QuickLinkService } from '../../../../../services/quick-link.service';
import { HomeworkExercisePreviewModalable } from '../../../../../models/homework-exercise-preview-modalable';
import { HomeworkService } from '../../../../../services/homework.service';
import { environment } from '../../../../../../environments/environment';
import { ModalComponent } from '../../../../../models/modal-component';
import { QuicklinkNumberHtmlPipe } from '../../../../../pipes/quicklink-number-html.pipe';
import { AssetPipe } from '../../../../../pipes/asset.pipe';

@Component({
    selector: 'app-homework-exercise-preview-modal',
    templateUrl: './homework-exercise-preview-modal.component.html',
    styleUrls: ['./homework-exercise-preview-modal.component.scss'],
    imports: [
        QuicklinkNumberHtmlPipe,
        AssetPipe
    ],
    standalone: true
})
export class HomeworkExercisePreviewModalComponent extends ModalComponent implements OnChanges {
    @Input() declare modalable: HomeworkExercisePreviewModalable;
    preview: string;

    constructor(public applicationStateService: ApplicationStateService,
                public quickLinkService: QuickLinkService,
                private homeworkService: HomeworkService,
                private modalService: ModalService) {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.modalable instanceof HomeworkExercisePreviewModalable) {
            this.preview = environment.externalUrls.preview(this.modalable?.quicklink);
        }
    }

    getId(): string {
        return HomeworkExercisePreviewModalable.MODAL_ID;
    }

    extractFilenameFromHTML = (htmlString: string): string | null => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        let src = '';

        const imgElement = doc.querySelector('img');

        if (imgElement && imgElement.hasAttribute('src')) {
            src = imgElement.getAttribute('src');
        }

        let text = src ? src : doc.body.textContent?.trim() || '';
        text = text.replace('\'', '').replace('"', '').replace('/', '');

        const filenameRegex = /^[^\\/:\*\?"<>\|]+\.[^\\/:\*\?"<>\|]+$/;
        if (filenameRegex.test(text)) {
            return text;
        }

        return null;
    };

    openExercise(): void {
        window.window.open(`/hsm/${this.modalable?.quicklink}`);
    }

    addExercise(): void {
        this.homeworkService.addHomeworkExerciseSubject.next({
            result: this.modalable.quicklink,
            teaser: this.modalable.teaser,
            preview: this.modalable.preview
        });
        this.modalService.closeModal(this.getId());
    }
}
